import { Component } from 'react'
import withRouter from '../components/withRouter'
import TopMenu from '../components/topmenu'
import MenuCard from '../components/menuCard'
import Logo from '../images/hit_logo.png'
import './all.css'
import { API } from 'aws-amplify'

class Home extends Component {
    constructor(props) {
        super(props)

        this.state = {
            menu: [
                { label: 'Clinical Viewer', css: 'Clinical', route: 'clinical' },
                { label: 'My Data Sharing', css: 'DataSharing', route: 'datasharing' },
                { label: '(New) My Data Sharing', css: 'DataSharing', route: 'iop' },
                { label: `Provider Access (EMR)`, css: 'EMR', route: 'emr' },
                { label: 'MPF Index File Download', css: 'PD', route: 'pd', function: 1 }
            ],
            splash: true,
            bounce: false,
            displayMsg: false,
            msg: '',
            json: null,
            jsonUrl: null,
            contract: '',
            pd: false,
            displaySettings: false
        }
        this.handleMenuSelected = this.handleMenuSelected.bind(this)
        this.handleLogOut = this.handleLogOut.bind(this)
        this.handleDisplaySettings = this.handleDisplaySettings.bind(this)
    }

    componentDidMount() {
        if (this.props.isAuthenticated) {
            setTimeout(() => this.setState({ splash: false }), 1000)
        } else {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('login', true)
            }, 3000)
        }
    }

    handleNavigate(page, history) {
        const { search } = this.props
        if (history) this.props.onAddHistory(search.pathname + search.search)
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleLogOut() {
        this.props.onLogout()
        this.handleNavigate('login')
    }

    handleDisplaySettings() {
        this.setState({ displaySettings: !this.state.displaySettings })
    }

    handleBack() {
        this.handleNavigate(`my/${this.state.route}s`, true)
    }

    handleMenuSelected(m) {
        if (this.state.menu[m].function) this.handleFunction(this.state.menu[m].function)
        else this.handleNavigate(this.state.menu[m].route, true)
    }

    handleFunction(f) {
        switch (f) {
            case 1:
                this.setState({ pd: true })
                break
            default:
                return false
        }
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleChange = event => {
        this.setState({ [event.target.id]: event.target.value.replace(/[<>//]/g, ""), topMenu: null })
    }

    handleFetchPD() {
        if (this.state.contract && this.state.contract.length === 5) {
            API.get('hit', `pd/${this.state.contract}`)
                .then(resp => this.setState({ json: resp, jsonUrl: `https://q8ye948ddl.execute-api.us-east-1.amazonaws.com/prod/pd/${this.state.contract}` }))
                .catch(err => {
                    this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Error Requesting Contract Index File', displayMsg: true })
                })
        }
    }

    getSplash() {
        return <div className='All-Splash'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
        </div>
    }

    getBounce() {
        return <div className='All-Bounce'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
            <div className='All-Content'>Get into Interop by Logging In or Joining HIT FHIR.</div>
        </div>
    }

    getMessage() {
        return <div className='All-Confirm'>
            <div className='All-Row All-Confirm-Text'>{this.state.msg}</div>
            <div className="All-Row All-Flex-Wrap">
                <div className='All-Button' style={{ backgroundColor: '#044f27' }} onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getMenu() {
        return <div className='All-Row All-Flex-Wrap'>
            {
                this.state.menu.map((m, midx) => {
                    return <MenuCard key={`menu-${midx}`} idx={midx} menu={m} onSelected={this.handleMenuSelected} />
                })
            }
        </div>
    }

    getJson() {
        return <div className='JSON-Container'>
            <div className='All-Row All-Flex'>
                <div className='All-TB-Label'>Contract</div>
                <input id='contract' className='All-Textbox' type='text' placeholder='H####' value={this.state.contract} onChange={this.handleChange} />
                <div className='All-Button' style={{ width: '100px', backgroundColor: '#3b09df', marginLeft: '10px' }} onClick={() => this.handleFetchPD()}>Submit</div>
            </div>
            <div className='JSON-URL All-Row'>{this.state.jsonUrl && <a href={`${this.state.jsonUrl}`}>{this.state.jsonUrl}</a>}</div>{this.state.json && <div className='All-Row'><pre>{JSON.stringify(this.state.json, undefined, 2)}</pre></div>}</div>
    }

    render() {
        //console.log(this.props, this.state)
        return <div className='All-Container'>
            <TopMenu user={this.props.user ? { firstName: this.props.user.firstName, image: this.props.user.image } : null} mode={this.props.mode} onLogout={this.handleLogOut} onSettings={this.handleDisplaySettings} displaySettings={this.state.displaySettings} card={this.props.user && this.props.user.card} />
            <div className='Home-Menu-Container'>
                {
                    this.state.splash ? this.getSplash() : (this.state.bounce ? this.getBounce() : this.getMenu())
                }
                {
                    this.state.displayMsg && this.getMessage()
                }
                {
                    this.state.pd && this.getJson()
                }
            </div>
        </div>
    }
}

export default withRouter(Home)


